import BeamImpact from "./BeamImpact";

/**
 * @namespace Fragments.Fragments/Beam
 */

export default BeamImpact;
